import { AxiosResponse } from 'axios';
import $api from '@/http/index';

export class VersionService {
    static async getVersion(): Promise<AxiosResponse<string>> {
        return $api.get<string>(`/version`);
    }
}
